/**
 * It's a .js file because it's consumed by "i18next-extract" plugin in
 * `.babelrc.js`, where TypeScript is not available.
 */

// @ts-check

/** @type {["en"]} */
const locales = ["en"];

/** @typedef {typeof locales[number]} LanguageCode */

/** @type {LanguageCode} */
const defaultLocale = "en";

module.exports = {
  defaultLocale,
  locales,
};
